import axios from '@/libs/api.request'
// 转换成pdf
export const transferPDF = data => {
  return axios.request({
    url: '/file/tools/word/to/pdf',
    responseType: 'blob',
    data,
    method: 'POST'
  })
}
export const file = { transferPDF }
